"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_REQUEST = void 0;
exports.CONFIG_REQUEST = 'dynamicRender/CONFIG_REQUEST';
//# sourceMappingURL=requestIndicator.js.map